(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spirit-customizer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-spirit-customizer]').forEach((root) => {
    const upload = root.querySelector('[data-upload]');
    const dropzone = root.querySelector('[data-dropzone]');
    const art = root.querySelector('[data-skin-art]');
    const empty = root.querySelector('[data-empty-art]');
    const fileRow = root.querySelector('[data-file-row]');
    const fileName = root.querySelector('[data-file-name]');
    const controls = root.querySelector('[data-image-controls]');
    const zoom = root.querySelector('[data-zoom]');
    const zoomValue = root.querySelector('[data-zoom-value]');
    const scale = root.querySelector('[data-scale]');
    const status = root.querySelector('[data-status]');
    let url = '';
    let position = { x: 50, y: 50 };
    let dragging = false;
    let previous = { x: 0, y: 0 };
    const update = () => {
      art.style.backgroundSize = `${zoom.value}% auto`;
      art.style.backgroundPosition = `${position.x}% ${position.y}%`;
      zoomValue.value = `${zoom.value}%`;
      scale.value = `${zoom.value}%`;
    };
    const show = (file) => {
      status.textContent = '';
      if (!file || !file.type.startsWith('image/')) {
        status.textContent = root.dataset.invalidType;
        return;
      }
      if (file.size > 15728640) {
        status.textContent = root.dataset.tooLarge;
        upload.value = '';
        return;
      }
      if (url) URL.revokeObjectURL(url);
      url = URL.createObjectURL(file);
      art.style.backgroundImage = `url("${url}")`;
      art.classList.add('has-image');
      empty.hidden = true;
      fileRow.hidden = false;
      controls.hidden = false;
      fileName.textContent = file.name;
      position = { x: 50, y: 50 };
      zoom.value = 100;
      update();
    };
    upload.addEventListener('change', (event) => show(event.target.files[0]));
    ['dragenter', 'dragover'].forEach((name) => dropzone.addEventListener(name, (event) => { event.preventDefault(); dropzone.classList.add('is-dragging'); }));
    ['dragleave', 'drop'].forEach((name) => dropzone.addEventListener(name, (event) => { event.preventDefault(); dropzone.classList.remove('is-dragging'); }));
    dropzone.addEventListener('drop', (event) => { upload.files = event.dataTransfer.files; show(event.dataTransfer.files[0]); });
    zoom.addEventListener('input', update);
    root.querySelector('[data-remove]').addEventListener('click', () => {
      if (url) URL.revokeObjectURL(url);
      url = '';
      art.style.backgroundImage = '';
      art.classList.remove('has-image');
      empty.hidden = false;
      fileRow.hidden = true;
      controls.hidden = true;
      upload.value = '';
      status.textContent = '';
    });
    art.addEventListener('pointerdown', (event) => {
      if (!url) return;
      dragging = true;
      previous = { x: event.clientX, y: event.clientY };
      art.setPointerCapture(event.pointerId);
    });
    art.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      position.x = Math.max(0, Math.min(100, position.x + (event.clientX - previous.x) / 2));
      position.y = Math.max(0, Math.min(100, position.y + (event.clientY - previous.y) / 4));
      previous = { x: event.clientX, y: event.clientY };
      update();
    });
    ['pointerup', 'pointercancel'].forEach((name) => art.addEventListener(name, () => { dragging = false; }));
  });

  } catch(e) { console.error(e); }
})();
})();
